import { WorkflowTransientStateResponseResponse } from '@asset-metrix/portal-gateway-client-js';
import { QueryFunction } from '@tanstack/react-query';

import { extractErrorMessage } from '../../utils/errorMessage';
import {
  QueryKeyWithRole,
  unwrapQueryKeyWithRole,
} from '../../utils/prependRoleId';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export const fetchTransientStateFromWorkflow: QueryFunction<
  WorkflowTransientStateResponseResponse,
  QueryKeyWithRole<[{ contentId: string }, { rowIds: string[] }]>
> = async ({ queryKey }) => {
  const [{ contentId }, { rowIds }] = unwrapQueryKeyWithRole(queryKey).params;

  const response =
    await portalGatewayClient.workflow.getTransientStateFromWorkflowController(
      contentId,
      { rowIdsToCheck: rowIds }
    );

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(response.error) || 'Error fetching footer data',
      response
    );
  }

  return response.data;
};
